import { h } from "omi";

import { IconProps } from "@/components";

export function FilePlusIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 88 89">
      <path
        d="M14.666 25.585c0-6.16 0-9.24 1.2-11.594a11 11 0 0 1 4.807-4.807c2.353-1.199 5.433-1.199 11.594-1.199h19.066l22 22V63.72c0 6.16 0 9.24-1.199 11.594a11 11 0 0 1-4.807 4.807c-2.353 1.199-5.433 1.199-11.594 1.199H32.267c-6.161 0-9.241 0-11.594-1.2a11 11 0 0 1-4.808-4.806c-1.199-2.353-1.199-5.434-1.199-11.594V25.585Z"
        fill="#fff"
      />
      <path
        d="M51.333 8.974v15.145c0 2.053 0 3.08.4 3.865.351.69.912 1.25 1.602 1.602.785.4 1.811.4 3.865.4h15.145M44 66.652v-22m-11 11h22M51.333 7.985H32.267c-6.161 0-9.241 0-11.594 1.2a11 11 0 0 0-4.808 4.806c-1.199 2.354-1.199 5.434-1.199 11.594V63.72c0 6.16 0 9.24 1.2 11.594a11 11 0 0 0 4.807 4.807c2.353 1.199 5.433 1.199 11.594 1.199h23.466c6.16 0 9.241 0 11.594-1.2a11 11 0 0 0 4.807-4.806c1.2-2.353 1.2-5.434 1.2-11.594V29.985l-22-22Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
